<template>
  <!-- 期刊列表 -->
  <div>
    <p class="total">找到{{ total }}条结果</p>
    <van-list
      v-model="loading"
      :finished="finished"
      :error="error"
      :finished-text="List.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="list-box" v-if="loading || List.length > 0">
        <BkItem
          class="list-item"
          v-for="item in List"
          :key="item.id"
          :cover="item.logo"
          :name="item.title"
          @click.native="toDetail(item.id)"
        />
      </div>
      <noneList noneType="search" v-else />
    </van-list>
  </div>
</template>

<script>
import BkItem from "@/views/mobileView/components/listItem/bkItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "Qk",
  components: { BkItem, noneList },
  props: {},
  data() {
    return {
      userPreferences: {
        pageNo: 0,
        pageSize: 20,
        queryParam: {
          configMap: {
            must: [
              {
                esField: "all",
                queryValue: this.$route.query.paramStr,
              },
              {
                esField: "type",
                queryValue: "4",
              },
            ],
          },
        },
      },
      List: [],
      total: 0,
      loading: false,
      finished: false,
      error: false,
    };
  },
  methods: {
    // 触底加载
    onLoad() {
      this.userPreferences.pageNo += 1;
      this.user();
    },
    // 搜索用户函数封装
    async user() {
      const resp = await this.$apis.searchServe.userList(this.userPreferences);
      if (resp.resultCode == 200) {
        this.List.push(...resp.data.list);
        this.finished = resp.data.list.length < 20;
        this.total = +resp.data.total;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    // 期刊跳转详情
    toDetail(id) {
      this.$router.push({
        path: "/appusesbaike",
        query: {
          item: 1,
          id,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.total {
  text-align: center;
  font-size: 13px;
  color: #999999;
  line-height: 19px;
}
.list-box {
  margin-top: 15px;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  .list-item {
    display: inline-block;
    margin:12px 1px 8px 12px;
    &:nth-child(3n) {
      margin-right: 12px;
    }
  }
}
</style>
